/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const ReportsContainer = styled(Box)(() => ({
  flex: 1,
  borderRadius: '0 8px 8px 0',

  '& .MuiTableContainer-root': {
    borderRadius: '0 8px 8px 0',
  },
}));

export const StatusChip = styled(Box)<{label: string}>(({label, theme}) => {
  const getStatusColors = (status: string) => {
    switch (status) {
      case 'success':
        return {
          backgroundColor: '#419466',
        };
      case 'crafting-report':
        return {
          color: theme?.palette?.semantic_dark?.primary.main,
          borderRadius: '12px',
          borderTop: `2px solid ${theme?.palette?.semantic_dark?.primary.main}`,
        };
      case 'error':
        return {
          backgroundColor: theme?.palette?.semantic_dark?.bad.onContainer,
        };
      default:
        return {
          backgroundColor: theme?.palette?.semantic_dark?.primary.container,
        };
    }
  };

  return {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 500,
    borderRadius: '9px',
    width: 'fit-content',
    padding: theme.spacing(0.5, 1),
    color: theme?.palette?.semantic_dark?.primary.on,
    ...getStatusColors(label),
  };
});

export const ReportBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
}));

export const ThanksBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const ThanksHeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.secondary.on,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0.16px',
}));

export const ThanksText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.secondary.on,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16px',
  letterSpacing: '0.28px',
}));
